import { render, staticRenderFns } from "./PhoneModal.vue?vue&type=template&id=9532e486&"
import script from "./PhoneModal.vue?vue&type=script&lang=js&"
export * from "./PhoneModal.vue?vue&type=script&lang=js&"
import style0 from "./PhoneModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports